import { render, staticRenderFns } from "./MediaUploadWidget.vue?vue&type=template&id=3ffbbf2a&scoped=true"
import script from "./MediaUploadWidget.vue?vue&type=script&lang=js"
export * from "./MediaUploadWidget.vue?vue&type=script&lang=js"
import style0 from "./MediaUploadWidget.vue?vue&type=style&index=0&id=3ffbbf2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_cache-loader@4.1.0_webpac_98d88fd53c1ad5e44e79d7b0571b6b60/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbbf2a",
  null
  
)

export default component.exports